import { Global } from "@emotion/react";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { DisclaimerModal } from "src/components/DisclaimerModal";
import { NotFound } from "src/components/NotFound";
import { DisclaimerProvider } from "src/contexts/DisclaimerContext";
import { SE_THEME } from "src/styles/se-energy.theme";

export const Route = createRootRouteWithContext<{
    queryClient: QueryClient;
}>()({
    component: RootComponent,
    notFoundComponent: () => {
        return <NotFound />;
    },
});

const environment = import.meta.env.VITE_ENVIRONMENT;

export function RootComponent() {
    return (
        <MantineProvider theme={SE_THEME} defaultColorScheme="light" forceColorScheme="light">
            <DisclaimerProvider>
                <Global
                    styles={() => ({
                        body: {
                            backgroundColor:
                                SE_THEME.colorScheme === "dark"
                                    ? SE_THEME.colors.dark[9]
                                    : SE_THEME.colors.gray[0],
                            margin: 0,
                            padding: 0,
                            fontFamily: SE_THEME.fontFamily,
                        },
                    })}
                />
                <Outlet />
                {environment && environment === "local" ? (
                    <TanStackRouterDevtools position="bottom-right" />
                ) : null}
                <Notifications />
                <DisclaimerModal />
            </DisclaimerProvider>
        </MantineProvider>
    );
}
